import React from "react";
import { Link } from "react-router-dom";

export const LinkColumnFormatter = (cellContent, row, rowIndex, {dIndexName}) => (
dIndexName ? <a href={row[dIndexName]} target="_blank">{row[dIndexName]}</a>  : '-' 
);
